import React from 'react';
import { useParams } from 'react-router-dom';
import ProductPagePlaceholder from '../components/ProductPagePlaceholder';
import Icon from '../components/Icon';

/* Onboarding section — each sub-route renders a placeholder until its real
   page is built. */
const SECTIONS: Record<string, { title: string; description: string; icon: React.ReactNode }> = {
  companies:  { title: 'Companies',  description: 'Manage onboarding companies here.', icon: <Icon name="customers" size={22} /> },
  messages:   { title: 'Messages',   description: 'Send and receive onboarding messages.', icon: <Icon name="messageCircle" size={22} /> },
};

const Onboarding: React.FC = () => {
  const { section } = useParams<{ section: string }>();
  const cfg = (section && SECTIONS[section]) || {
    title: 'Onboarding',
    description: 'Select an onboarding section from the menu.',
    icon: <Icon name="bookOpen" size={22} />,
  };
  return <ProductPagePlaceholder title={cfg.title} description={cfg.description} icon={cfg.icon} />;
};

export default Onboarding;
